import React, { memo } from 'react';
import { CalendarGrid } from '../components/CalendarGrid';
import { ScheduleItem } from '../types/scheduleItem.types';
import { TimeScale } from '../types/calendar.types';

interface DayViewProps {
  currentDate: Date;
  dayViewDays: number;
  items: ScheduleItem[];
  timeScale: TimeScale;
  onItemClick?: (item: ScheduleItem) => void;
  onItemDragStart?: (e: React.DragEvent, item: ScheduleItem) => void;
  onItemDragEnd?: () => void;
  onDrop?: (e: React.DragEvent, date: Date, time: Date) => void;
  onCreateClick?: (date: Date, time: Date) => void;
  allowDrag?: boolean;
  onOpenWorkOrder?: (invoiceDocId: number) => void;
}

export const DayView: React.FC<DayViewProps> = memo(({
  currentDate,
  dayViewDays,
  items,
  timeScale,
  onItemClick,
  onItemDragStart,
  onItemDragEnd,
  onDrop,
  onCreateClick,
  allowDrag = true,
  onOpenWorkOrder,
}) => {
  return (
    <CalendarGrid
      viewType="day"
      dayViewDays={dayViewDays}
      currentDate={currentDate}
      items={items}
      timeScale={timeScale}
      onItemClick={onItemClick}
      onItemDragStart={onItemDragStart}
      onItemDragEnd={onItemDragEnd}
      onDrop={onDrop}
      onCreateClick={onCreateClick}
      allowDrag={allowDrag}
      onOpenWorkOrder={onOpenWorkOrder}
    />
  );
});

DayView.displayName = 'DayView';
